module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d82da95d61c2bd2b7d3b8fa7815e1ae5.png";